import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import Particle from "../Particle";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(process.env.REACT_APP_FORMSPREE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json", // Important for JSON API
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.ok) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        alert("Failed to send message. Try again later.");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="project-section" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 1 }}>
        <Particle />
      </div>

      <Container
        style={{
          paddingTop: "100px",
          paddingBottom: "50px",
          position: "relative",
          zIndex: 2,
        }}
      >
        <Form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            backgroundColor: "#1c1c1c",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <Form.Group controlId="formName" className="mb-3">
            <Form.Label style={{ color: "white" }}>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId="formEmail" className="mb-3">
            <Form.Label style={{ color: "white" }}>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId="formMessage" className="mb-3">
            <Form.Label style={{ color: "white" }}>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter your message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Button variant="outline-light" type="submit" className="w-100" disabled={loading}>
            {loading ? "Sending..." : "Send"}
          </Button>
        </Form>
      </Container>
    </Container>
  );
}

export default Contact;